import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsPlatformTopicUpdate } from '@/learnpaths/components/LearnpathsAddElementsPlatformTopicUpdate/LearnpathsAddElementsPlatformTopicUpdate'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsPlatformTopicUpdate {...params} />
}
